import React from 'react';
import {
  VirtualizedTableCellProps,
  VirtualizedTableColumnFit,
  VirtualizedTableColumnProps,
  VirtualizedTableRowProps,
} from './VirtualizedTable.interface';
import { VirtualizedDisplayCell } from './VirtualizedDisplayCell';
import { VirtualizedEditableCell } from './VirtualizedEditableCell';

export interface VirtualizedTableRowColumnsCellPops {
  row: VirtualizedTableRowProps;
  columnFit: VirtualizedTableColumnFit;
  columns: VirtualizedTableColumnProps[];
  editMode: boolean;
  rowEditCellValues: VirtualizedTableCellProps[] | null;
  onEditCellChange: (cellIndex: number, newValue: string) => void;
  onMultiSelectClick?: (rowIndex: number) => void;
}

export const VirtualizedTableRowColumnsCell: React.FC<
  VirtualizedTableRowColumnsCellPops
> = ({
  row,
  columnFit,
  columns,
  editMode,
  rowEditCellValues,
  onEditCellChange,
  onMultiSelectClick,
}) => {
  return (
    <>
      {row.cells.map((cell, cellIndex) => {
        return (
          <div
            role="cell"
            className="cell"
            key={cellIndex}
            style={{
              maxWidth:
                columnFit !== VirtualizedTableColumnFit.Fit &&
                columns[cellIndex] &&
                columns[cellIndex].width
                  ? columns[cellIndex].width + 'px'
                  : undefined,
            }}
          >
            {editMode &&
            columns[cellIndex] &&
            columns[cellIndex].editable &&
            rowEditCellValues ? (
              <VirtualizedEditableCell
                focus={cellIndex === 0}
                value={rowEditCellValues[cellIndex].value}
                onEditCellChange={value => onEditCellChange(cellIndex, value)}
                columnType={columns[cellIndex].type}
                onMultiSelectionClick={() => {
                  if (!onMultiSelectClick) {
                    return;
                  }

                  onMultiSelectClick(cellIndex);
                }}
              />
            ) : (
              <VirtualizedDisplayCell
                cell={cell}
                editable={
                  columns[cellIndex].editable && row.isEditable === undefined
                    ? true
                    : row.isEditable ?? false
                }
                columnType={columns[cellIndex].type}
                onClick={() => {
                  cell.onClick ? cell.onClick(row.key, cell.key) : undefined;
                }}
              />
            )}
          </div>
        );
      })}
    </>
  );
};
